var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNexlaLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nexla Logo/Icon/Blue",
    clipPath: "url(#clip0_24285_10335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.27511 7.1629L0.0578713 5.9295C-0.0192904 5.85135 -0.0192904 5.72474 0.0578713 5.64599L5.01955 0.621544C5.41493 0.221114 5.94131 0 6.50118 0C7.06105 0 7.58683 0.220509 7.9828 0.621544L10.821 3.49603C10.8982 3.57418 10.8982 3.70079 10.821 3.77954L9.6038 5.01233C9.52664 5.09048 9.40162 5.09048 9.32386 5.01233L6.84512 2.50192C6.6555 2.30989 6.34745 2.30989 6.15784 2.50192L1.55505 7.1629C1.47789 7.24104 1.35287 7.24104 1.27511 7.1629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.45965 9.6C8.92311 9.6 8.38657 9.39343 7.97863 8.97967L5.14039 6.10518C5.06323 6.02704 5.06323 5.90043 5.14039 5.82167L6.35763 4.58888C6.43479 4.51074 6.55981 4.51074 6.63757 4.58888L9.11632 7.09929C9.30593 7.29133 9.61398 7.29133 9.80359 7.09929L14.4447 2.39894C14.5218 2.3208 14.6468 2.3208 14.7246 2.39894L15.9418 3.63173C16.019 3.70988 16.019 3.83649 15.9418 3.91524L10.9413 8.97967C10.5327 9.39343 9.9962 9.6 9.45965 9.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24285_10335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9.6,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexlaLogoBlack);
export default __webpack_public_path__ + "static/media/nexla-logo-black.9f693dce8df6e98707800ec52a6b9cb6.svg";
export { ForwardRef as ReactComponent };